<template>
  <div class="d-bar">
    <div class="container">
      <div class="row justify-content-center d-none d-sm-none d-md-flex">
        <div
          class="col-2"
          style="cursor: pointer"
          @click="$router.push('/select')"
        >
          {{ t("message.selectGTs") }}
        </div>
        <div
          class="col-2"
          v-if="currentProject.length > 0"
          :style="{
            position: 'relative',
          }"
        >
          <label for="file-input" style="cursor: pointer">
            <font-awesome-icon
              :icon="['fas', 'file-upload']"
              class="icon"
            ></font-awesome-icon>
            <input
              :style="{ opacity: 0, height: 0, overflow: 'hidden' }"
              type="file"
              name="file-input"
              id="file-input"
              accept=".zip"
              @change="handleFileInput"
              hidden
            />
            {{ t("message.import") }}
          </label>
        </div>
        <div class="col-2" style="cursor: pointer">
          <save-inlay></save-inlay>
        </div>
      </div>
    </div>
  </div>
  <div class="container-xl">
    <div
      class="row d-none d-sm-none d-md-flex h-100"
      v-if="currentProject.length > 0"
    >
      <!-- Projektliste -->
      <div class="col-5">
        <div class="list-container">
          <div class="list">
            <div
              style="
                height: 30px;
                border-bottom: 1px solid #ffde00;
                margin-bottom: 10px;
              "
            >
              {{ t("message.inlays") + " " + currentProjectName }}
            </div>
            <ul class="text-start list-rows">
              <li
                v-for="(inlay, index) in currentProject"
                :key="'inlay_' + index"
                class="inlay_list"
              >
                <div class="row justify-content-between">
                  <div class="col-8">
                    <div class="row">
                      <div class="col-1">
                        <input
                          type="checkbox"
                          name=""
                          id=""
                          :value="index"
                          v-model="selectedInlays"
                          @click="selectInlay(index)"
                        />
                      </div>
                      <div class="col-lg col-sm">
                        <p
                          class="d-inline text-break"
                          :class="activeInlay == index ? 'active-inlay' : ''"
                        >
                          {{ inlay["project-name"] }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-4 text-end">
                    <div class="d-inline pe-lg-2 pe-sm-1">
                      <font-awesome-icon
                        :icon="['far', 'eye']"
                        class="icon"
                        size="lg"
                        @click="slideTo(index)"
                      ></font-awesome-icon>
                      <div class="tooltiptext">{{ t("message.view") }}</div>
                    </div>
                    <div class="d-inline pe-lg-2 pe-sm-1">
                      <font-awesome-icon
                        :icon="['far', 'edit']"
                        class="icon"
                        size="lg"
                        @click="editSelected(inlay, index)"
                      ></font-awesome-icon>
                      <div class="tooltiptext">{{ t("message.edit") }}</div>
                    </div>
                    <div class="d-inline pe-lg-2 pe-sm-1">
                      <font-awesome-icon
                        :icon="['far', 'copy']"
                        class="icon"
                        size="lg"
                        @click="copySelected(inlay)"
                      ></font-awesome-icon>
                      <div class="tooltiptext">{{ t("message.copy") }}</div>
                    </div>
                    <div class="d-inline">
                      <font-awesome-icon
                        :icon="['far', 'trash-alt']"
                        class="icon"
                        size="lg"
                        @click="deleteInlay(index)"
                      ></font-awesome-icon>
                      <div class="tooltiptext">{{ t("message.delete") }}</div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="row">
            <div class="col-10 mb-2">
              <button
                class="btn-outline-lcn btn"
                @click="selectAll"
                style="width: 45%"
              >
                {{ t("message.selectAll") }}
              </button>
              <button
                class="btn btn-outline-lcn ms-2"
                @click="printSelected()"
                style="width: 45%"
              >
                {{ t("message.print") }}
              </button>
            </div>
            <div class="col-1">
              <div class="d-inline">
                <font-awesome-icon
                  :icon="['far', 'question-circle']"
                  class="icon"
                  size="lg"
                ></font-awesome-icon>
                <div class="tooltiptext-print" lang="de">
                  {{ t("message.printBorder") }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-10">
              <button
                class="btn-outline-lcn btn me-2 mb-3"
                @click="saveSelection"
                style="width: 45%"
                v-if="selectedInlays.length > 0"
              >
                {{ t("message.saveSelected") }}
              </button>
              <button
                class="btn-outline-lcn btn mb-3"
                @click="deleteSelection"
                style="width: 45%"
                v-if="selectedInlays.length > 0"
              >
                {{ t("message.deleteSelected") }}
              </button>
            </div>
          </div>
          <div class="pb-2">
            <button class="btn btn-outline-lcn" @click="showOverview">
              {{ t("message.showOverview") }}
            </button>
          </div>
        </div>
      </div>
      <div class="col-7 swiper-list">
        <div class="row justify-content-center">
          <div class="col-11">
            <swiper
              :slides-per-view="1"
              :direction="'vertical'"
              :allow-touch-move="false"
              :pagination="{ clickable: true }"
              @swiper="onSwiper"
            >
              <SwiperSlide
                v-for="(gt, index) in currentProject"
                :key="'gt_' + index"
              >
                <!-- GT6L Preview -->
                <template v-if="gt.name.includes('gt6l')">
                  <div
                    class="col-sm-1 preview"
                    :style="{
                      width: gt.gtDim.width / 3 + 'px',
                      height: gt.gtDim.height / 3 + 'px',
                    }"
                  >
                    <div
                      class="inlay"
                      :style="{
                        'background-color':
                          gt.preview.style['background-color'],
                        'background-image':
                          gt.preview.style['background-image'],
                        'background-size': gt.preview.style['background-size'],
                        height: tinyView(gt.preview.style.height, 'i-heihgt'),
                        top: tinyView(gt.preview.style.top, 'i-top'),
                        left: tinyView(gt.preview.style.left, 'i-left'),
                        width: tinyView(gt.preview.style.width, 'i-width'),
                      }"
                    ></div>
                    <div v-for="(inlay, index) in gt.inlay" :key="index">
                      <div
                        class="gt-btn"
                        v-for="(btn, btn_index) in inlay.btns"
                        :key="'index_' + btn_index"
                        :style="{
                          height: tinyView(btn.style.height, 'btn-height'),
                          width: tinyView(btn.style.width, 'btn-width'),
                          background: btn.style.background,
                          'background-image': btn.style['background-image'],

                          'background-size': btn.style['background-size'],
                          'background-position':
                            btn.style['background-position'],
                          top: tinyView(btn.style.top, 'btn-top', index, gt),
                          left: tinyView(btn.style.left, 'btn-left', index, gt),
                          border: btn.style['border-color']
                            ? '1px solid ' + btn.style['border-color']
                            : '',
                          'border-radius': btn.style['border-radius'],
                          'background-position': 'top',
                        }"
                      >
                        <div
                          class="gt-btn-img"
                          :style="{
                            'background-image':
                              btn.style.image['background-image'],
                            'background-position':
                              btn.style.image['background-position'],
                            'background-size':
                              btn.style.image['background-size'],
                            filter: btn.style.image.filter,
                            height: tinyView(btn.style.height, 'btnimg-height'),
                            width: tinyView(btn.style.width, 'btn img-width'),
                          }"
                        ></div>
                      </div>
                    </div>
                  </div>
                </template>
                <glass-taster :gt="gt" :editor="false"></glass-taster>
              </SwiperSlide>
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="currentProject.length < 1">
      <div class="col-7">
        <div
          @drop="handleFileDrop"
          @dragover="onDragOver"
          @dragleave="onDragLeave"
        >
          <input
            class="dropzone"
            :style="{ 'border-style': dragOver ? 'solid' : 'dashed' }"
            type="file"
            name="file-input"
            id="file-input"
            accept=".zip"
            @change="handleFileInput"
          />
          <label for="file-input"></label>
        </div>
      </div>
    </div>
    <preview-modal
      v-if="showPreview"
      @close="showPreview = false"
      @selectImport="selectInlay($event)"
      :imported="importedInlays"
    ></preview-modal>
  </div>
</template>

<script>
import { ref, computed, reactive, onMounted } from "vue";
import JSZip from "jszip";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import GlassTaster from "./GTComponent.vue";
import PreviewModal from "../views/components/PreviewModal.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import SaveInlay from "./SaveInlay.vue";
import { useI18n } from "vue-i18n";
import { printAllInlays, print } from "@/modules/printInlay";
import { saveSelectedToZip } from "@/modules/saveInlay";

export default {
  components: {
    GlassTaster,
    Swiper,
    SwiperSlide,
    SaveInlay,
    PreviewModal,
  },
  setup() {
    onMounted(() => {
      window.addEventListener("beforeunload", (event) => {
        event.preventDefault();
        // Chrome requires returnValue to be set.
        return (event.returnValue =
          "Do you really want to leave? you have unsaved changes!");
      });
    });
    const dragOver = ref(false);
    const store = useStore();
    const currentProject = computed(() => store.getters.currentProject);
    const parsedInlays = computed(() => store.getters.parsedInlays);
    const draggableTexts = computed(() => store.getters.draggableTexts);
    const currentProjectName = computed(() => store.getters.currentProjectName);
    const selectedInlays = ref([]);
    const router = useRouter();
    const swiperInstance = reactive({});
    const { t } = useI18n();
    const showPreview = ref(false);
    const importedInlays = ref([]);
    function onSwiper(swiper) {
      swiperInstance.value = swiper;
    }

    function handleFileDrop(event) {
      let droppedFile = event.dataTransfer.files[0];
      if (!droppedFile) return;
      let zip = new JSZip();
      zip.loadAsync(droppedFile).then(
        (zip) => {},
        () => {
          alert("Not a valid zip file");
        }
      );
      dragOver.value = false;
    }
    function handleFileInput(event) {
      showPreview.value = true;
      importedInlays.value = [];
      let file = event.target.files[0];
      // console.log(event);
      if (!file) return;
      store.dispatch("setProjectName", file.name.split("_")[0]);

      let zip = new JSZip();
      zip.loadAsync(file).then(
        (contents) => {
          Object.keys(contents.files).forEach((filename) => {
            zip
              .file(filename)
              .async("text")
              .then(function (content) {
                let importedInlay = {};
                let dummyDom = document.createElement("html");
                dummyDom.innerHTML = content;
                let group =
                  dummyDom.getElementsByTagName("body")[0].firstChild
                    .classList[0];
                if (group == "inlay")
                  group =
                    dummyDom.getElementsByTagName("body")[0].firstChild
                      .classList[1];
                if (group == "gt6l") {
                  importedInlay.gtDim = parsedInlays.value[group][0].gtDim;
                  importedInlay["project-name"] = filename.substr(
                    0,
                    filename.indexOf(".")
                  );
                  importedInlay.name = group;
                  importedInlay.group = group;
                  let gt6ls = dummyDom.getElementsByClassName("gt6l-container");
                  let inlays = [];

                  //FIX: gotta figure out why this is happening? is it consumed somehow?????
                  inlays.push(parseHTML(gt6ls[0]));
                  inlays.push(parseHTML(gt6ls[0]));
                  inlays.push(parseHTML(gt6ls[0]));

                  importedInlay.preview = makePreview(inlays);
                  readjustBtns(inlays);
                  importedInlay.inlay = inlays;
                } else {
                  importedInlay.inlay = parseHTML(content);
                }
                importedInlay.gtDim = parsedInlays.value[group][0].gtDim;
                let old_dim = JSON.parse(JSON.stringify(importedInlay.gtDim));
                if (!Array.isArray(importedInlay.inlay)) {
                  if (importedInlay.inlay.style.horizontal) {
                    importedInlay.gtDim.topHeight = old_dim.lWidth;
                    importedInlay.gtDim.botHeight = old_dim.rWidth;
                    importedInlay.gtDim.lWidth = old_dim.topHeight;
                    importedInlay.gtDim.rWidth = old_dim.botHeight;
                    importedInlay.gtDim.width = old_dim.height;
                    importedInlay.gtDim.height = old_dim.width;
                  }
                }

                if (Array.isArray(importedInlay.inlay)) {
                  if (importedInlay.inlay[0].style.horizontal) {
                    importedInlay.gtDim.topHeight = old_dim.lWidth;
                    importedInlay.gtDim.botHeight = old_dim.rWidth;
                    importedInlay.gtDim.lWidth = old_dim.topHeight;
                    importedInlay.gtDim.rWidth = old_dim.botHeight;
                    importedInlay.gtDim.width = old_dim.height;
                    importedInlay.gtDim.height = old_dim.width;
                  }
                }
                // console.log(parsedInlays.value[group][0].gtDim);
                importedInlay["project-name"] = filename.substr(
                  0,
                  filename.indexOf(".")
                );
                importedInlay.name = group;
                importedInlay.group = group;
                //let's import the GTBackground but since not all older inlays might have one we will generically declare it first and then overwrite if it exists
                importedInlay.gtBackground = "white";
                if (
                  dummyDom.getElementsByClassName("gtbackground").length > 1
                ) {
                  importedInlay.gtBackground =
                    dummyDom.getElementsByClassName(
                      "gtbackground"
                    )[0].innerText;
                }
                // console.log(importedInlay);
                store.dispatch("addInlayToProject", importedInlay);
                importedInlays.value.push(importedInlay);
                // console.log(importedInlays.value, "imported Inlays");
                store.dispatch("setCurrentInlay", currentProject.value[0]);
                // console.log(currentProject.value);
              });
          });
        },
        () => {}
      );
    }
    function makePreview(inlays) {
      let preview = {};
      let btns = [],
        leds = [];
      preview.style = inlays[0].style;
      inlays.forEach((inlay) => {
        inlay.btns.forEach((btn) => {
          btns.push(btn);
        });
        inlay.leds.forEach((led) => {
          leds.push(led);
        });
      });
      preview.btns = btns;
      preview.leds = leds;
      inlays[1].style.top = inlays[0].style.top;
      inlays[2].style.top = inlays[0].style.top;
      return preview;
    }
    function readjustBtns(inlays) {
      for (let i = 1; i < inlays.length; i++) {
        if (inlays[i].btns.length == 1) {
          inlays[i].btns[0].style.top = "19.1mm";
        } else {
          inlays[i].btns[0].style.top = "19.1mm";
          inlays[i].btns[1].style.top = "56.1mm";
        }
      }
    }
    function parseHTML(content) {
      //let's make a dummyDOM so we can use document Selection on it and dont have to do substrings
      let dummyDOM = document.createElement("html");
      let new_inlay = {};
      //copy the html contents of the file into our dummyDOM
      if (typeof content == "string") dummyDOM.innerHTML = content;
      else dummyDOM.append(content);
      let inlays = dummyDOM.getElementsByClassName("inlay");
      let horizontal_dim =
        dummyDOM.getElementsByClassName("horizontal").length > 0;
      //every inlay needs its structure as seen in actions.js importXML function
      //TODO: Es gibt nur ein inlay, warum foreach???? HAHAHAHA GT6L you
      inlays.forEach((inlay) => {
        // console.log(inlay, inlay.classList);
        new_inlay.btns = [];
        new_inlay.leds = [];
        new_inlay.style = {
          top: inlay.style.top,
          height: inlay.style.height,
          width: inlay.style.width,
          left: inlay.style.left,
          "background-image": inlay.style["background-image"].replaceAll(
            '"',
            "'"
          ),
          "background-color": inlay.style["background-color"],
          background: inlay.style.background,
          "background-size": inlay.style["background-size"],
          "background-position": inlay.style["background-position"],
          horizontal: horizontal_dim,
        };
        new_inlay.bgImgTransform = "";
        new_inlay.showImg = false;
        new_inlay.selectedText = [];
        new_inlay.ledRad = 0;
        new_inlay.showLEDs = false;
        new_inlay.showBargraph = false;
        new_inlay.showBargraphCaptions = false;
        new_inlay.bargraph = [];
        new_inlay.selectedBarGType = "BargraphLED";
      });

      //lets get the buttons and the styles from the dummyDOM so we can import them
      let buttons = dummyDOM.getElementsByClassName("gt-btn");
      buttons.forEach((button) => {
        // console.log(button.style);
        let btn = {
          style: {
            height: button.style.height,
            top: button.style.top,
            width: button.style.width,
            left: button.style.left,
            border: button.style.border,
            "border-radius": button.style["border-radius"],
            background: button.style.background,
            image: {
              "background-position": button.firstChild.style.backgroundPosition,
              "background-image":
                button.firstChild.style.backgroundImage.replaceAll('"', "'"),
              "background-size": button.firstChild.style.backgroundSize,
              filter: button.firstChild.style.filter,
            },
            gradient: {
              firstColour: "#ffffff",
              secondColour: "#ffffff",
            },
          },
          content: {
            content: button.children[1].firstChild.textContent,
            "d-content": true,

            style: {
              "align-items": button.children[1].classList[3],
              "justify-content": button.children[1].classList[2],
              "font-family": button.children[1].firstChild.style.fontFamily,
              color: button.children[1].firstChild.style.color,
              "font-style": button.children[1].firstChild.style.fonstStyle,
              "font-size": button.children[1].firstChild.style.fontSize,
              "font-weight": button.children[1].firstChild.style.fontWeight,
              "text-decoration":
                button.children[1].firstChild.style.textDecoration,

              "background-position":
                button.children[1].firstChild.style.backgroundPosition,
            },
          },
        };
        if (btn.style.background.includes("linear")) {
          btn.style.gradient.firstColour = btn.style.background.substring(
            16,
            33
          );
          btn.style.gradient.secondColour = btn.style.background.substring(
            35,
            51
          );
        }
        new_inlay.btns.push(btn);
      });

      // get the leds and add them to the inlay
      let leds = dummyDOM.getElementsByClassName("led");
      leds.forEach((led) => {
        let newLed = {
          style: {
            height: led.style.height,
            width: led.style.width,
            top: led.style.top,
            left: led.style.left,
            display: led.style.display,
          },
        };
        new_inlay.leds.push(newLed);
        if (led.style.display != "none") new_inlay.showLEDs = true;
      });

      //as a last measure lets import the bargraph LEDs (if there are any)
      let bargraph = dummyDOM.getElementsByClassName("bar_g");
      let captions = dummyDOM.getElementsByClassName("bar_g_caption");
      bargraph.forEach((barGLED) => {
        let id_type = barGLED.id.split("_");
        let led = {
          type: id_type[0],
          id: parseInt(id_type[1]),
          style: {
            top: barGLED.style.top,
            left: barGLED.style.left,
            height: barGLED.style.height,
            width: barGLED.style.width,
            "background-color": barGLED.style.backgroundColor,
          },
          caption: {},
        };
        if (barGLED.style.display != "none") {
          new_inlay.showBargraph = true;
          new_inlay.selectedBarGType = led.type;
        }
        new_inlay.bargraph.push(led);
      });
      if (captions.length > 0) {
        new_inlay.bargraphCaptionsRight =
          (captions[0].style.left == "46.85mm" &&
            captions[0].style.top == "22.55mm") ||
          (captions[0].style.left == "22.55mm" &&
            captions[0].style.top == "46.85mm" &&
            new_inlay.style.horizontal);
      }
      captions.forEach((caption) => {
        let content = {};
        //Für alte Edge-Cases
        if (
          new_inlay.bargraphCaptionsRight &&
          new_inlay.style.horizontal &&
          captions[0].style.top == "22.55mm"
        ) {
          content = {
            content: caption.innerText,
            style: {
              top:
                caption.style.left == "46.15mm"
                  ? "46.65mm"
                  : caption.style.left,
              left: caption.style.top,
              color:
                caption.style.color.length > 0 ? caption.style.color : "black",
            },
          };
          //Ansonsten importiere normal
        } else {
          content = {
            content: caption.innerText,
            style: {
              top: caption.style.top,
              left: caption.style.left,
              color:
                caption.style.color.length > 0 ? caption.style.color : "black",
            },
          };
        }

        //let's find the graphled for the caption and put the content in
        let isEqual = (led) => led.id == parseInt(caption.id);
        let idx = new_inlay.bargraph.findIndex(isEqual);
        new_inlay.bargraph[idx].caption = content;
        if (caption.style.display != "none")
          new_inlay.showBargraphCaptions = true;
      });
      new_inlay.draggableTexts = [];
      let draggableTexts = dummyDOM.getElementsByClassName("drag_text");
      draggableTexts.forEach((draggableText) => {
        new_inlay.draggableTexts.push({
          top: draggableText.style.top,
          left: draggableText.style.left,
          content: draggableText.innerText,
          editable: false,
          id: draggableText.id,
          style: {
            "font-size": draggableText.style["font-size"],
            color: draggableText.style.color,
            "font-family": draggableText.style["font-family"],
            "font-weight": draggableText.style["font-weight"],
            "font-style": draggableText.style["font-style"],
            "text-decoration": draggableText.style["text-decoration"],
            transform: draggableText.style.transform,
          },
        });
      });
      // console.log(new_inlay);
      return new_inlay;
    }

    function onDragOver() {
      dragOver.value = true;
    }
    function onDragLeave() {
      dragOver.value = false;
    }
    function editSelected(inlay, index) {
      store.dispatch("setCurrentInlay", inlay);
      store.commit("setCurrentInlayIndex", index);
      store.commit("emptySaveInlay");
      store.dispatch("saveInlay");
      router.push("/editor");
    }
    function selectInlay(inlayIdx) {
      if (!selectedInlays.value.includes(inlayIdx)) {
        selectedInlays.value.push(inlayIdx);
      } else {
        selectedInlays.value.splice(selectedInlays.value.indexOf(inlayIdx), 1);
      }
    }

    const activeInlay = ref(0);
    function slideTo(index) {
      swiperInstance.value.slideTo(index, 200, true);
      activeInlay.value = index;
    }
    function deleteInlay(index) {
      if (confirm("Wirklich löschen? Dies ist unwiderruflich")) {
        store.dispatch("removeInlay", index);
      }
    }
    function printSelected() {
      printAllInlays(selectedInlays.value.map((i) => currentProject.value[i]));
      print();
      selectedInlays.value = [];
    }
    function selectAll() {
      currentProject.value.forEach((inlay, index) => {
        selectedInlays.value.push(index);
      });
    }
    function copySelected(inlay) {
      store.dispatch("addInlayToProject", inlay);
    }
    function saveSelection() {
      let selection = [];
      selectedInlays.value.forEach((index) => {
        selection.push(currentProject.value[index]);
      });
      saveSelectedToZip(currentProjectName.value, selection);
    }

    //TODO: Delete Bug because I'm an idiot
    function deleteSelection() {
      if (confirm("Wirklich löschen? Dies ist unwiderruflich")) {
        selectedInlays.value.forEach((index) => {
          store.dispatch("removeInlay", index);
        });
        selectedInlays.value = [];
      }
    }
    function showOverview() {
      showPreview.value = true;
      importedInlays.value = currentProject.value;
    }
    //Returns the reduced size for a given css size value - this is used for the GT6L Preview
    function tinyView(mmValue, trigger, index = null, gt = null) {
      let smol = "";

      if (
        (trigger == "btn-top" && gt.inlay[0].btns[0].style.width == "24mm") ||
        (trigger == "btn-left" && gt.inlay[0].btns[0].style.width != "24mm")
      ) {
        smol =
          ((parseFloat(mmValue.substring(0, mmValue.length - 2)) + index * 94) *
            3.7795275591) /
          3;
      } else {
        smol =
          (parseFloat(mmValue.substring(0, mmValue.length - 2)) *
            3.7795275591) /
          3;
      }
      return smol + "px";
    }

    return {
      handleFileDrop,
      handleFileInput,
      dragOver,
      onDragOver,
      onDragLeave,
      currentProject,
      editSelected,
      selectInlay,
      selectedInlays,
      onSwiper,
      t,
      deleteInlay,
      draggableTexts,
      printSelected,
      selectAll,
      slideTo,
      copySelected,
      activeInlay,
      currentProjectName,
      saveSelection,
      deleteSelection,
      showPreview,
      importedInlays,
      showOverview,
      tinyView,
    };
  },
};
</script>

<style lang="scss" scoped>
// .inlay_list input[type="checkbox"] {
// }
.d-bar {
  height: 50px;
  padding: 10px;
  background-color: #fff;
  line-height: 30px;
}
.dropzone {
  border: 2px dashed #ffdd00;
  width: 400px;
  height: 200px;
}
.list-container {
  margin-top: 50px;
  box-shadow: 0px 17px 21px 2px rgba(227, 227, 227, 0.55);
  -webkit-box-shadow: 0px 17px 21px 2px rgba(227, 227, 227, 0.55);
  -moz-box-shadow: 0px 17px 21px 2px rgba(227, 227, 227, 0.55);
}
ul {
  box-shadow: none;
  padding-bottom: 5px;
}
ul li {
  padding-bottom: 5px;
}
.swiper-list {
  overflow: hidden;
  // max-height: calc(100vh - 200px);
}
.swiper-container-vertical > .swiper-pagination-bullets {
  right: 50px !important;
  top: 100px !important;
}
.active-inlay {
  font-weight: bold;
}
.swiper-slide .slider-container {
  margin: auto;
}
.swiper-container {
  height: calc(100vh - 132px);
}
@media (min-resolution: 108dpi) {
  .list-rows {
    max-height: 50vh !important;
  }
}
.list-rows {
  max-height: 65vh;
  overflow-y: auto;
  /* width */
  &::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
.preview {
  display: inline-block;
  float: left;
  border: 2px solid grey;
  border-radius: 5px;
  position: relative;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-left: 80px;
  overflow: hidden;
  p {
    margin-bottom: 5px !important;
    z-index: 100;
    white-space: pre-line;
  }
}
.tooltiptext {
  display: none;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}
.icon {
  cursor: pointer;
}
.d-inline:hover .tooltiptext {
  display: block;
}
.tooltiptext-print {
  display: none;
  width: 200px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px;
  border-radius: 6px;
  // line-break: normal;
  // overflow-wrap: break-word;
  // word-break: break-word;
  hyphens: auto;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}
.d-inline:hover .tooltiptext-print {
  display: block;
}
.gt-btn {
  border: 1px dashed grey;
  position: absolute;
  display: grid;
}
.gt-btn-img {
  background-repeat: no-repeat;
  z-index: 5;
  height: 100%;
  width: 100%;
  grid-row-start: 1;
  grid-column-start: 1;
  pointer-events: none;
}

.inlay {
  position: absolute;
  background-repeat: no-repeat;
}
.gt-top,
.gt-bottom {
  position: absolute;
  left: 0;
  z-index: 10;
  background-color: #fff;
}
.gt-top {
  top: 0;
}
.gt-bottom {
  bottom: 0;
}
.gt-right,
.gt-left {
  position: absolute;
  z-index: 10;
  background-color: #fff;
}
.gt-right {
  right: 0;
}
.gt-left {
  left: 0;
}

.inlay-name {
  margin-top: 50px;
}
.gt-btn-container {
  height: 100%;
  width: 100%;
  grid-row-start: 1;
  grid-column-start: 1;
  pointer-events: auto;
}
</style>
